import { useQuery } from "react-query";
import { InterviewerResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllInterviewerKey = "all-interviewer-key";

export async function fetchAllInterviewer(): Promise<InterviewerResponse[]> {
  const res = await ApiClient.get(`/AllInterviewers`);
  return res.data;
}

export default function useFetchAllInterviewer() {
  return useQuery([fetchAllInterviewerKey], queryWrapper(fetchAllInterviewer));
}
